import { defineLocaleTargets } from './utilities';

export const CommonSection = 'common';

export const CommonLocales = defineLocaleTargets(CommonSection, <const>{
	addToCart: '',
	back: '',
	buyNow: '',
	cancel: '',
	chooseYourDate: '',
	confirm: '',
	correctErrorsBelow: '',
	close: '',
	continue: '',
	date: '',
	decrease: '',
	description: '',
	each: '',
	email: '',
	from: '',
	homepage: '',
	increase: '',
	loading: '',
	loadingDates: '',
	logo: '',
	logout: '',
	makeSelection: '',
	menu: '',
	navigation: '',
	next: '',
	phoneNumber: '',
	quantity: 'qty',
	reload: '',
	remove: '',
	retry: '',
	retryInSecondsPlural: '',
	retryInOneSecond: '',
	returnToCart: '',
	selectDate: '',
	selectLanguage: '',
	selectYourQuantities: '',
	unsavedChangesConfirm: '',
	updating: '',
	viewCart: '',
	viewLess: '',
	viewLessDates: '',
	viewMore: '',
	viewMoreDates: '',
	pagenotfound: '',
	pagenotfounddesc: '',
});
